module.exports = __webpack_public_path__ + "img/illustration-1.dc19b050.svg";